import React from "react";

const Register = () => {
  return (
    <div>
      <h1>Rejestracja</h1>
      {/* Formularz rejestracji */}
    </div>
  );
};

export default Register;